module.exports = __webpack_public_path__ + "img/img-tick.e74af9db.svg";